import React from 'react';
import { MailIcon, GlobeIcon } from 'lucide-react';
export function Footer() {
  return <footer className="border-t border-azul-dark bg-bg-footer py-10" data-id="element-80" data-mp="2082j57csaif4">
      <div className="mx-auto flex max-w-6xl flex-col items-center gap-4 px-4 text-center sm:px-6" data-id="element-81" data-mp="209x4unvvqek9">
        <p className="font-heading text-lg font-semibold uppercase tracking-wide text-white" data-id="element-82" data-mp="2f2h61izgybz2">
          🏐 VOLEY-PRO 360 — Sistema Sesión en Mano
        </p>
        <div className="flex flex-wrap items-center justify-center gap-x-6 gap-y-2 text-sm text-white/80" data-id="element-83" data-mp="1mgxu0z71l8j1">
          <a href="https://www.manualeslistos.com" className="flex items-center gap-1.5 transition-colors hover:text-naranja-light" data-id="element-84" data-mp="1himjsncu4w0a">
            <GlobeIcon size={14} data-id="element-85" data-mp="1rez8t7xfqlop" />
            www.manualeslistos.com
          </a>
          <a href="mailto:manualeslistos@gmail.com" className="flex items-center gap-1.5 transition-colors hover:text-naranja-light" data-id="element-86" data-mp="13pen4h9wdabq">
            <MailIcon size={14} data-id="element-87" data-mp="yoh6wa8g6qcv" />
            manualeslistos@gmail.com
          </a>
        </div>
        <p className="text-xs text-white/50" data-id="element-88" data-mp="1efzm4wjjocep">
          © VOLEY-PRO 360 {new Date().getFullYear()} — Todos los derechos reservados.
        </p>
      </div>
    </footer>;
}